import { render, staticRenderFns } from "./IvfBalance.vue?vue&type=template&id=46321d69&scoped=true"
import script from "./IvfBalance.vue?vue&type=script&lang=js"
export * from "./IvfBalance.vue?vue&type=script&lang=js"
import style0 from "./IvfBalance.vue?vue&type=style&index=0&id=46321d69&prod&scoped=true&lang=css"
import style1 from "./IvfBalance.vue?vue&type=style&index=1&id=46321d69&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46321d69",
  null
  
)

export default component.exports